import React, { useEffect } from 'react';
import { useTheme, useMediaQuery, Typography, Stack } from '@mui/material';
import T from 'prop-types';

import { ContentWrapper } from 'elements';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ReportExportDialog from 'components/ReportExportDialog';
import { getMachine } from 'redux/machines/actions';
import MachineDetailsAccordion from 'containers/Machines/MachinesDetail/MachineDetailsAccordion';
import { DetailsWrapper } from './BatchRecordsDetails.styled';
import InfoBlocks from './InfoBlocks';
import SensorComparisonBlock from './SensorComparisonBlock';
import { BatchResponse } from '../../helpers/propTypes';
import BatchNotes from './batchNotes/batchNotes';
import { getBatchNotes, getMachines } from '../../redux/rootSelectors';
import { getAllBatchNotesByBatchIdAction } from '../../redux/batch_notes/actions';
import Breadcrumbs from '../elements/Breadcrumbs';

const BatchRecordsDetails = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const name = data.details.batch_id ? data.details.batch_id : t('batch_records.overview.items');
  const isMobile = useMediaQuery('(max-width:425px)');
  const { getMachineResponse } = useSelector(getMachines);

  // Get all batches notes for batch details
  const { batchNotes, batchLoadingState } = useSelector(getBatchNotes);
  useEffect(() => {
    dispatch(getAllBatchNotesByBatchIdAction(data.details.id));
  }, [dispatch, data]);

  const getAllBatchNotes = () => {
    dispatch(getAllBatchNotesByBatchIdAction(data.details.id));
  };

  useEffect(() => {
    if (data?.machine_id) dispatch(getMachine(data?.machine_id));
  }, [dispatch, data]);

  const breadcrumbObj = [
    { route: '/batch-records', name: `${t('batch_records.title')}` },
    { route: null, name: `${t('batch_records.batch_details')}` }
  ];

  return (
    <>
      <ContentWrapper maxWidth={false}>
        <DetailsWrapper theme={theme}>
          <Breadcrumbs data={breadcrumbObj} />
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 'bold' }}>{name}</Typography>
            <ReportExportDialog batch={data} />
          </Stack>
          <InfoBlocks data={data} />
          {!!getMachineResponse?.id && <MachineDetailsAccordion machine={getMachineResponse} />}
          <BatchNotes
            loadingState={batchLoadingState}
            data={Array.isArray(batchNotes) ? batchNotes : []}
            reloadAction={getAllBatchNotes}
            isMobile={isMobile}
          />
          <SensorComparisonBlock mobile={isMobile} />
        </DetailsWrapper>
      </ContentWrapper>
    </>
  );
};

BatchRecordsDetails.propTypes = {
  data: T.shape(BatchResponse).isRequired
};

export default BatchRecordsDetails;
